export default function StoryOverview() {
  const pillars = [
    {
      icon: 'ri-chat-history-line',
      title: '剧情总览',
      desc: '以时间线整理故事走向，把主线、支线与暗线拆开来讲，读起来不再一头雾水。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '角色设定',
      desc: '收录主要人物的性格、立场与成长轨迹，谁在推谁，一眼看清。',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: '伏笔回收',
      desc: '逐格追查被忽略的细节，把作者埋下的机关一个个翻出来。',
    },
    {
      icon: 'ri-scales-3-line',
      title: '结局探讨',
      desc: '汇总主流解读与预测，开放讨论、理性交锋，一起推演结局真相。',
    },
  ];

  return (
    <section id="story" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              故事全貌
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black text-foreground-900 md:text-4xl">
              一个关于成长、选择与真相的故事
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-700">
              《嘿咻嘿咻漫画》以热血冒险为主线，却在笑闹与打斗之间埋下大量细思极恐的暗线。表面上主角一路打怪升级，实际上每个选择都在悄然改写整个世界的规则。本文站把这些线索整理成清晰的脉络，让你既能爽快追更，也能品味藏在分镜里的巧思。
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              无论你是刚入坑的新读者，还是想回头复盘的老粉，都能在这里找到想要的答案。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              {['热血冒险', '轻松搞笑', '暗线反转', '群像成长'].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900 whitespace-nowrap"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {pillars.map((item) => (
              <div
                key={item.title}
                className="rounded-lg bg-background-100 p-5 ring-1 ring-background-200/70 transition-transform duration-300 hover:-translate-y-1"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}